import { Icon, IconProps } from "./Icon";

export function IconPrivateEntrance(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M19 21V3.26A1.4 1.4 0 0 0 17.55 2H16V0h-.59L5 2.47V21H0v1h5.33l9.88 2H16V3h1.53c.27 0 .47.15.47.29V22h6v-1Zm-13 .19v-18l9-2.08V23Zm6.03-11.17h1v2h-1z" />
    </Icon>
  );
}
